import Appointments from '../pages/appointment/pages/Appointments'
import CreateAppointment from '../pages/appointment/pages/CreateAppointment'
import { USER_ROLES } from '../utils/userRole'

const permissions = [USER_ROLES.ADMIN]

const AppointmentRoutes = [
  {
    path: '/appointments',
    component: Appointments,
    exact: true,
    permissions: [USER_ROLES.ADMIN, USER_ROLES.USER],
  },
  {
    path: '/appointment/create',
    component: CreateAppointment,
    exact: true,
    permissions,
  },
  {
    path: '/appointment/edit/:id',
    component: CreateAppointment,
    exact: true,
    permissions,
  },
]

export default AppointmentRoutes
